import { render, staticRenderFns } from "./generate-review-link.vue?vue&type=template&id=436996c1&scoped=true"
import script from "./generate-review-link.vue?vue&type=script&lang=js"
export * from "./generate-review-link.vue?vue&type=script&lang=js"
import style0 from "./generate-review-link.vue?vue&type=style&index=0&id=436996c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436996c1",
  null
  
)

export default component.exports